var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tongxin-layout"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v(" 醫師介紹 ")]), _vm._m(0), _c('div', {
    staticClass: "fixed-footer-navigation"
  }, [_c('TongxinNavigation', {
    attrs: {
      "canProceed": !_vm.isLoading,
      "backButtonIsVisible": true,
      "nextButtonIsVisible": true,
      "textForNextStep": "下一步"
    },
    on: {
      "back": _vm.goBack,
      "next": _vm.handleSubmit
    }
  })], 1), _vm.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "doctor-info"
  }, [_c('div', {
    staticClass: "doctor-info__name"
  }, [_vm._v("葉柏綸醫師")]), _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("@/assets/images/web/tongxin/bg_content_22.png"),
      "alt": "Doctor illustration"
    }
  }), _c('div', {
    staticClass: "doctor-info__description"
  }, [_c('div', {
    staticClass: "doctor-info__description__label"
  }, [_vm._v("科別")]), _c('div', {
    staticClass: "doctor-info__description__value"
  }, [_vm._v("家醫科")])]), _c('div', {
    staticClass: "doctor-info__description"
  }, [_c('div', {
    staticClass: "doctor-info__description__label"
  }, [_vm._v("學經歷")]), _c('div', {
    staticClass: "doctor-info__description__value"
  }, [_vm._v("國立台灣大學醫學院")])]), _c('div', {
    staticClass: "doctor-info__description"
  }, [_c('div', {
    staticClass: "doctor-info__description__label"
  }, [_vm._v("專長")]), _c('div', {
    staticClass: "doctor-info__description__value"
  }, [_vm._v("內兒科/肝膽腸胃科/耳鼻喉科/皮膚科/心電圖/肺功能/腹部超音波")])])]);
}]

export { render, staticRenderFns }